import "./App.css";
import "@aws-amplify/ui-react/styles.css";
import CssBaseline from "@mui/material/CssBaseline";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import MypageLayout from "./components/layout/MypageLayout";
import Login from "./pages/Login";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import Accounts from "./pages/Accounts";
import History from "./pages/History";
import Wait from "./pages/Wait";
import SignUp from "./pages/SignUp";
import SignUpConform from "./pages/SignUpConform";
import ForgotPass from "./pages/ForgotPass";
import ForgotPassConform from "./pages/ForgotPassConform";
import SeeQr from "./pages/SeeQr";
import RewardSetting from "./pages/RewardSetting";
import HistoryApply from "./pages/HistoryApply";
import HistoryTransfer from "./pages/HistoryTransfer";
import Unsubscribe from "./pages/Unsubscribe";
import UnsubscribeComplete from "./pages/UnsubscribeComplete";
import Lp from "./pages/Lp";
import Company from "./pages/Company";
import Agreement from "./pages/Agreement";
import ExternalRedirect from "./components/ExternalRedirect";
import Faq from "./pages/Faq";
import News from "./pages/News";
import RewardSettingProvider from "./contexts/RewardSettingContext";
import FinishEKyc from "./pages/reward/setting/ekyc/finish";
import StartEKyc from "./pages/reward/setting/ekyc/start";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#15B855",
    },
    secondary: {
      main: "#15B855",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === "contained" &&
            ownerState.color === "primary" && {
            color: "white",
            backgroundColor: "#15B855",
            padding: "12px",
            fontWeight: "bold",
          }),
          ...(ownerState.variant === "outlined" &&
            ownerState.color === "primary" && {
            color: "#15B855",
            // backgroundColor: "#15B855",
            borderColor: "#15B855",
            // fontWeight: "bold",
            padding: "12px",
          }),
        }),
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          fontSize: "0.95rem",
          ...(ownerState.variant === "h1" && {
            fontSize: "1.5rem",
            fontWeight: "bold",
          }),
          ...(ownerState.variant === "h1" && {
            fontSize: "1.3rem",
          }),
        }),
      },
    },
  },
});

const App = () => {
  return (
    <>
      <BrowserRouter>
        <div className="App">
          <CssBaseline />
          <ThemeProvider theme={theme}>
            <Routes>
              <Route path="/" element={<MypageLayout />}>
                <Route index element={<Lp />} />
                <Route path="login" element={<Login />} />
                <Route path="signup">
                  <Route index element={<SignUp />} />
                  <Route path="conform" element={<SignUpConform />} />
                </Route>
                <Route path="wait" element={<Wait />} />
                <Route path="forgot/pass" element={<ForgotPass />} />
                <Route path="forgot/confirm" element={<ForgotPassConform />} />
                <Route path="company" element={<Company />} />
                <Route path="agreement" element={<Agreement />} />
                <Route
                  path="contact"
                  element={
                    <ExternalRedirect to="https://nosh.jp/contact" />
                  }
                />
                <Route path="faq" element={<Faq />} />
                <Route path="news" element={<News />} />

                <Route path="mypage">
                  <Route path="accounts" element={<Accounts />} />
                  <Route path="accounts/qr" element={<SeeQr />} />
                  <Route path="history" element={<History />} />
                  <Route path="history/apply" element={<HistoryApply />} />
                  <Route
                    path="history/transfer"
                    element={<HistoryTransfer />}
                  />
                  <Route
                    path="reward/setting"
                    element={
                      <RewardSettingProvider>
                        <RewardSetting />
                      </RewardSettingProvider>
                    }
                  />
                  <Route path="reward/setting/ekyc/start" element={<StartEKyc />} />
                  <Route path="reward/setting/ekyc/finish" element={<FinishEKyc />} />
                  <Route path="unsubscribe" element={<Unsubscribe />} />
                </Route>
                <Route
                  path="unsubscribe/complete"
                  element={<UnsubscribeComplete />}
                />
              </Route>
            </Routes>
          </ThemeProvider>
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;
